export default __webpack_public_path__ + "static/media/3.fa6df4a5.png";